import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import {
    HomePage,
    LoginGate,
    ListWallboardsPage,
    WallboardPage,
    NotFoundPage,
} from './pages/pages';

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
    <BrowserRouter>
        <LoginGate>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="wallboards" element={<ListWallboardsPage />} />
                <Route path="wallboards/:wallboardId" element={<WallboardPage />} />
                <Route path="*" element={<NotFoundPage />} />
            </Routes>
        </LoginGate>
    </BrowserRouter>
);